import Category from '@/views/category/Category.vue';
export default [
  {
    path: '/category',
    name: 'category',
    meta: {
      keepAlive: true
    },
    component: Category
  },
  {
    path: '/productList/:type/:keyword?',
    name: 'productList',
    meta: {
      keepAlive: true
    },
    component: () =>
      import(
        /* webpackChunkName: "productList" */ '@/views/productList/ProductList.vue'
      )
  },
  {
    path: '/specificSearchResult',
    name: 'specificSearchResult',
    meta: {
      keepAlive: true
    },
    component: () =>
      import(
        /* webpackChunkName: "specificSearchResult" */ '@/views/productList/SpecificSearchResult.vue'
      )
  }
];
